import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';


interface SupportModalProps {
  open: boolean;
  onClose: () => void;
}

const SupportModal = ({open, onClose}: SupportModalProps) => {
  return (
    <>
    <Dialog onClose={onClose} open={open}>
      <Box style={{ padding: '10px' }}>
        <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5">Contact Support</Typography>
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body1">
              If you need assistance, please reach out to our support team.
            </Typography>
          </DialogContentText>
          <Typography variant="body1" component={'span'} style={{ fontWeight: 'bold' }}>
            Contact Information<br />
          </Typography>
          <Typography variant="body1" component="span">
            Email: <a href="mailto:help@hpair.org">help@hpair.org</a>
          </Typography>
        </DialogContent>
      </Box>
    </Dialog>
    </>
  );
};

export default SupportModal;
